import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { Search } from '../../shared/models/search/search.model';
import { ValidatedResponse } from '../../shared/models/validated-response.model';
import { BusinessTransactionSuggestionResult } from '../models/business-transaction-suggestion-result.model';
import { WipSearchResult } from '../models/wip-search-result.model';
import { QueuedSearchResult } from '../models/queued-search-result.model';

@Injectable()
export class WipSearchService extends BaseApiService {
    public getCustomerWipOpenServices(customerId: string): Observable<Search<any, WipSearchResult[]>> {
        return this.get('Foundation/BusinessTransaction/Customer/Open/' + customerId);
    }

    public getLimitedCustomerWipOpenServices(customerId: string): Observable<Search<any, WipSearchResult[]>> {
        return this.get('Foundation/BusinessTransaction/Customer/Open/' + customerId + '/Limited');
    }

    public getCustomerGroupServices(agentNumberId: number, agentQueueCheck: boolean) {
        return this.get('Foundation/BusinessTransaction/Agent/Group/' + agentNumberId + '/' + agentQueueCheck);
    }

    public getServicesGroupAssignedToUser(agentNumberId: number, assignedUserLoginId: number): Observable<Search<any, WipSearchResult[]>> {
        return this.get('Foundation/BusinessTransaction/AssignedTo/Group/' + agentNumberId + '/' + assignedUserLoginId);
    }

    public getServiceTypes(serviceAreaId) {
        return this.get('Foundation/BusinessTransaction/Area/' + serviceAreaId + '/Type');
    }
    public getServiceTypeParam(businessTransactionTypeId, customerNumberId) {
        return this.get('Foundation/BusinessTransaction/Param/' + businessTransactionTypeId + '/Customer/' + customerNumberId);
    }

    public getCustomerQueuedServices(customerId: string): Observable<ValidatedResponse<QueuedSearchResult[]>> {
        return this.get('Foundation/BusinessTransaction/Queued/Customer/' + customerId);
    }

    public getSuggestedServices(customerId: string): Observable<ValidatedResponse<BusinessTransactionSuggestionResult>> {
        return this.get('Foundation/BusinessTransaction/Services/Suggest/' + customerId);
    }

    public getStuckTransactions(minAge: number, maxAge: number) {
        return this.get('Foundation/BusinessTransaction/SearchStuckTransaction/' + minAge + '/' + maxAge);
    }

    public getStuckTransactionsByBusinessTransactionNumber(businessTransactionNumberId: number) {
        return this.get('Foundation/BusinessTransaction/SearchStuckTransaction/' + businessTransactionNumberId);
    }

    public getWipDocument(wipId: string) {
        return this.get('Foundation/WipDocument/' + wipId);
    }

    public getValidatedWipDocument(wipId: string) {
        return this.get('Foundation/WipDocument/Validated/' + wipId);
    }

    public saveWipDocument(wipDocumentJson: string) {
        return this.post('Foundation/WipDocument', wipDocumentJson);
    }

    public getWipDocumentByBusinessTransactionNumber(businessTransactionNumberId: number) {
        return this.get('Foundation/WipDocument/BusinessTransactionNumber/' + businessTransactionNumberId);
    }
}
